const en = {
    orders: {
        delivery_modal: {
            cost_tooltip: 'The cost of this service is {fee} % of the products value in order, but no lesser than {currencyCode} {insurancePrice} + VAT (if applied). Insurance fee will be added to shipping price.'
        }
    }
}

const lt = {
    orders: {
        delivery_modal: {
            cost_tooltip: 'Papildomas siuntos draudimas kainuoja {fee} % bendros siuntos vertės, bet nemažiau nei {currencyCode} {insurancePrice} +  PVM (jeigu taikoma) ir mokestis bus automatiškai įtrauktas į pristatymo kainą.'
        }
    }
}

export default {en, lt}



// WEBPACK FOOTER //
// ./src/i18n/orders.js